export default {
  en: {
    USER_EMAIL_ADDRESS: 'Email Address',
    USER_EMAIL_ADDRESS_TT: 'This email will be used to send the invite and for further account correspondence.',
    USER_EMAIL_ADDRESS_DEFAULT: 'support@ringba.com',
    USER_INVALID_EMAIL: 'Looks like there is a typo in your email address.',
    USER_EMAIL_CONFIRM: 'Confirm Email',
    USER_EMAIL_CONFIRM_TT: 'Confirm user\'s email address.',
    USER_INVALID_CONFIRM_EMAIL: 'This does not match the above email address.',
    FIRST_NAME: 'First Name',
    FIRST_NAME_TT: 'Enter user\'s first name.',
    USER_FIRST_NAME_DEFAULT: 'John',
    LAST_NAME: 'Last Name',
    LAST_NAME_TT: 'Enter your Buyer\'s last name.',
    USER_LAST_NAME_DEFAULT: 'Smith',
    INVITE_USER_SUBMIT_BUTTON: 'Invite',
    INVITE_USER: 'Invite User',
    NO_INVITED_USERS: 'You have not invited any users.',
    COPY_INVITE_URL: 'Copy invitation URL',
    DELETE_INVITE: 'Delete Invite',
    DELETE_USER: 'Delete User',
    LOADING_INVITES: 'Loading Invites.',
    DELETE: 'Delete',
    CANCEL: 'Cancel',
    NO_ACCEPTED_INVITES: 'There are no accepted invites',
    NO_PENDING_INVITES: 'There are no pending invites',
    NO_EXPIRED_INVITES: 'There are no expired invites',
    NO_DECLINED_INVITES: 'You have not declined any users.',
    DELETE_MODAL_TITLE_USER: 'Delete User',
    DELETE_MODAL_TITLE_INVITE: 'Delete Invite',
    DELETE_MODAL_TEXT_USER: 'Are you sure you want to remove {firstName} {lastName} ({email}) from this account?',
    DELETE_MODAL_TEXT_INVITE: 'Are you sure you want to delete invite for <strong>{email}</strong>?',
    DELETE_INVITE_SUCCESS: 'Invite deleted successfully',
    DELETE_INVITE_FAIL: 'Failed to delete invite',
    DELETE_INVITE_SUCCESS: 'User removed successfully',
    DELETE_INVITE_FAIL: 'Failed to remove user',
    CREATE_INVITE_SUCCESS: 'User invited successfully',
    CREATE_INVITE_FAIL: 'Failed to invite user',
    COPY_URL_SUCCESS: 'Invite URL copied to clipboard',
    COPY_URL_FAIL: 'Failed to copy invite URL to clipboard',
  }
};